<template>
  <div>
    <PhotographerNav></PhotographerNav>
    <div class="h-screen flex overflow-hidden bg-gray-100">
      <div class="md:flex md:flex-shrink-0">
        <div class="flex flex-col w-36 sm:w-56 md:w-64 bg-gray-800">
          <div class="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="mt-5 flex-1 px-2 bg-gray-800">
              <router-link
                v-if="user && (user.role === 'admin')"
                :to="{ name: 'admin' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="home"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Site Admin.
                </div>
              </router-link>

                <div
                    v-if="user"
                    class="mt-1 nav-link hover:text-white hover:bg-gray-700"
                    @click="handleDisplayGroupsClick"
                >
                  <font-awesome-icon
                      icon="object-group"
                      size="2x"
                      class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Display Groups
                </div>

              <router-link
                  v-if="user && (user.role === 'photographer') && !user.outfitter_id"
                  :to="{ name: 'admin' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                      icon="hat-cowboy"
                      size="2x"
                      class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Outfitters
                </div>
              </router-link>
              <router-link
                v-if="user && user.role === 'outfitter'"
                :to="{ name: 'dashboard' }"
              >
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="home"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Dashboard
                </div>
              </router-link>
              <router-link :to="{ name: 'photographer' }">
                <div class="mt-1 nav-link hover:text-white hover:bg-gray-700">
                  <font-awesome-icon
                    icon="layer-group"
                    size="2x"
                    class="fa-fw nav-icon"
                  ></font-awesome-icon>
                  Uploader
                </div>
              </router-link>
            </nav>
          </div>
          <div class="flex-shrink-0 flex bg-gray-700 p-4">
            <a href="#" class="flex-shrink-0 group block focus:outline-none">
              <div class="flex items-center"></div>
            </a>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <main
          class="flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6"
          tabindex="0"
        >
          <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 mt-5">
            <Uploader></Uploader>
          </div>
        </main>
      </div>
    </div>

    <!-- Outfitter Selection Modal -->
    <base-modal :show="showOutfitterModal" @close="showOutfitterModal = false" @save="handleOutfitterSelect">
      <template v-slot:header>Select Outfitter</template>
      <template v-slot:main>
        <div>
          <base-label>Outfitter</base-label>
          <el-select
            v-model="selectedOutfitterId"
            filterable
            placeholder="Select an outfitter"
            class="w-full"
          >
            <el-option
              v-for="outfitter in outfitters"
              :key="outfitter.id"
              :label="outfitter.name"
              :value="outfitter.id"
            >
            </el-option>
          </el-select>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import PhotographerNav from "@/components/ui/nav/PhotographerNav";
import Uploader from "../components/photographer/Uploader";

export default {
  name: "Photographer",
  components: {
    Uploader,
    PhotographerNav,
  },
  data() {
    return {
      showOutfitterModal: false,
      selectedOutfitterId: null,
    };
  },
  methods: {
    handleDisplayGroupsClick() {
      if (this.user && this.user.outfitter_id) {
        // User has an outfitter_id, proceed directly
        this.handleToDisplayGroups(this.user.outfitter_id);
      } else {
        // User doesn't have an outfitter_id, show modal
        this.showOutfitterModal = true;
      }
    },
    handleOutfitterSelect() {
      if (!this.selectedOutfitterId) {
        this.$notify({
          title: "Selection Required",
          message: "Please select an outfitter",
          type: "warning",
        });
        return;
      }
      this.showOutfitterModal = false;
      this.handleToDisplayGroups(this.selectedOutfitterId);
    },
    handleToDisplayGroups(outfitter_id) {
      this.$store
          .dispatch("auth/set_outfitter_id", outfitter_id)
          .then((oid) => {
            this.$store.dispatch("outfitter/reload_outfitter", oid);
            // Open display groups in a new tab
            const route = this.$router.resolve({ path: "/dashboard/display-groups" });
            window.open(route.href, '_blank');
          });
    },
  },
  computed: {
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
    outfitters: function () {
      return this.$store.getters["outfitter/getOutfitters"];
    },
  },
};
</script>

<style scoped>
.nav-link {
  @apply cursor-pointer flex text-gray-300 items-center px-2 py-2 text-sm leading-5 font-medium rounded-md  transition ease-in-out duration-150;
}
.nav-icon {
  @apply mr-3 h-6 w-6 text-gray-300 transition ease-in-out duration-150;
}
.router-link-active .nav-link {
  @apply text-white bg-gray-900;
}
</style>
